import { level, linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { smaAt } from "../math/movingAverages";

const PERCENT = 100;

// How far the high rose over the previous high (DeMax) and the low fell
// under the previous low (DeMin); none on the first bar
const highRiseReader = (bars) => (index) =>
  index < 1 ? NaN : Math.max(0, bars[index].high - bars[index - 1].high);

const lowFallReader = (bars) => (index) =>
  index < 1 ? NaN : Math.max(0, bars[index - 1].low - bars[index].low);

/**
 * DeMarker (research §1.4). Not in TradingView, the classic MetaTrader
 * formula: SMA(DeMax) / (SMA(DeMax) + SMA(DeMin)) over Period, in percent
 * as the PO levels 70 / 30; 0 when the price did not move at all.
 */
export default {
  id: "demarker",
  name: "DeMarker",
  isOscillator: true,
  decimals: 2,
  inputs: [
    periodInput("period", "Period", 14, { max: 100 }),
  ],
  plots: [
    linePlot("value", "Main Line", PALETTE.AQUA),
  ],
  levels: [level(70, PALETTE.LIME), level(30, PALETTE.RED)],

  calculate: (bars, { period }, series, fromIndex) => {
    const readRise = highRiseReader(bars);
    const readFall = lowFallReader(bars);

    for (let index = fromIndex; index < bars.length; index += 1) {
      const rise = smaAt(readRise, index, period);
      const total = rise + smaAt(readFall, index, period);

      series.value[index] = total === 0 ? 0 : (PERCENT * rise) / total;
    }
  },
};
